import React from 'react'

export const browseListIcon = (MuiIcon, className = '') => (
  <div className={['icon', className].filter(Boolean).join(' ')}>
    <MuiIcon />
  </div>
)
